(function ($) {
}(window.jQuery));

jQuery(($) => {
    function share () {
        bindTap($('.page-utils .share').hammer(), 'button', (el) => {
            popupSocialLinks(el);
        });

        bindTap($('ul.social-links').hammer(), 'a.social-link', (el) => {
            setSocialLinkElements(el);
        });

        $('.page-utils .share').on('doubletap', function (el) {
            popupSocialLinks(el);
        });

        $('.page-utils .share').keydown((event) => {
            if (event.keyCode === $.ui.keyCode.ENTER) {
                bindEnterKey($('.page-utils .share').hammer(), 'button', (el) => {
                    popupSocialLinks(el);
                });
            }
        });

        $('ul.social-links').keydown((event) => {
            if (event.keyCode === $.ui.keyCode.ENTER) {
                bindEnterKey($('ul.social-links').hammer(), 'a.social-link', (el) => {
                    setSocialLinkElements(el);
                });
            }
        });
    }

    function setSocialLinkElements (el) {
        let width = 600;
        let height = 600;
        if ($(el).data('width')) width = $(el).data('width');
        if ($(el).data('height')) height = $(el).data('height');
        const win = window.open(el.href, '', `menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=${height},width=${width}`);
        if ($(el).hasClass('email')) {
            setTimeout(() => { win.close(); }, 200);
        }
        $(el).closest('.share').removeClass('active');
    }

    function popupSocialLinks (el) {
        $(el).closest('.share').toggleClass('active');
        $(el).closest('.share').removeAttr('style');
    }

    function bindEnterKey (delegator, selector, callback) {
        delegator.on('click', selector, function (e) {
            e.preventDefault();
            e.stopPropagation();
            callback(this);
        });
    }

    function bindTap (delegator, selector, callback) {
        delegator.delegate(selector, 'click', (e) => {
            e.preventDefault();
            e.stopPropagation();
        }).delegate(selector, 'tap', function (e) {
            e.preventDefault();
            e.stopPropagation();
            callback(this);
        });
    }

    function initPrintUtility () {
        $('.page-utils li.print.hidden').removeClass('hidden');
        bindTap($('.page-utils').hammer(), 'li.print', () => {
            $('.page-utils li.share').removeClass('active');
            window.print();
        });
        $('.page-utils li.print').keydown((event) => {
            if (event.keyCode === $.ui.keyCode.ENTER) {
                $('.page-utils li.share').removeClass('active');
                window.print();
            }
        });
    }

    function shareButtonRemoveFocus () {
        $(document).click(() => {
            $('.page-utils li.share').removeClass('active');
        });
        $(document).keydown((event) => {
            if (event.keyCode === $.ui.keyCode.ENTER) {
                $('.page-utils li.share').removeClass('active');
            }
        });

        $('.copy-link').focusout(function () {
            $('.share').removeClass('active');
        });

        $('.copy-link').on('swipe', function () {
            $('.share').removeClass('active');
        });
    }

    share();
    initPrintUtility();
    shareButtonRemoveFocus();
});



// WEBPACK FOOTER //
// ./src/js/app/share-print.js